<div *ngFor="let categoryInput of myInputs">
  <triv-input [fGroup]="formG1" [data]="categoryInput"></triv-input>
</div>
<br>
<h3>Einwilligung zur Eintragung von Weiterbildungszeit und Weiterbildungsmaßnahmen</h3>
<p>Ich willige hiermit ein, dass {{ gutBeratenLabel }} (kurz: Bildungsdienstleister) meine
  Teilnahme an allen in ihrer Verantwortung stehenden und von mir absolvierten anerkannten
  Weiterbildungsmaßnahmen sowie die damit erreichte Weiterbildungszeit an die Weiterbildungsdatenbank (WBD) des
  Berufsbildungswerks der Deutschen Versicherungswirtschaft (BWV) e. V. meldet. Diese Einwilligung gilt auch für die
  Zukunft.</p>
<p>Diese Einwilligung ist jederzeit von mir schriftlich mit Wirkung für die Zukunft widerrufbar. Der
  Bildungsdienstleister hat dann unverzüglich die Meldungen einzustellen.</p>

<p>Ich sichere für die Vergangenheit ausdrücklich zu, dass ich persönlich an allen für mich zu meldenden
  Weiterbildungsmaßnahmen teilgenommen habe. Sofern ich nur partiell an einer Weiterbildungsmaßnahme teilnehmen konnte,
  stelle ich sicher, dass der Bildungsdienstleister darüber informiert ist.</p>

<p>Für die Zukunft sichere ich ausdrücklich zu, dass ich persönlich an allen für mich tatsächlich zu meldenden
  Weiterbildungsmaßnahmen teilnehmen werde. Sofern ich nur partiell teilnehmen kann oder gänzlich verhindert bin, stelle
  ich sicher, dass der Bildungsdienstleister darüber informiert ist.</p>

<p>Ich werde dem Bildungsdienstleister alle Informationen zukommen lassen, die für eine korrekte Meldung meiner
  Weiterbildungsmaßnahmen erforderlich sind. Sofern ich trotz meiner eingehaltenen Informationsverpflichtung erkenne,
  dass Eintragungen zu meinen Weiterbildungsmaßnahmen nicht korrekt sind, mache ich den Bildungsdienstleister darauf
  aufmerksam.</p>

